<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>
    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div class="md-layout-item md-size-90 mx-auto text-center" style="margin-bottom:0px">
            <h2 class="title text-primary black" style="margin-top:0px">{{$t('Cultural events')}}</h2>
          </div>
          <div
            class="md-layout md-layout-item md-size-75 md-medium-size-90 md-xsmall-size-95 mx-auto md-gutter"
            v-if="items.length"
          >
            <template v-if="recommendedItems.length">
              <div class="agenda-section-label md-layout-item md-size-100">{{ $t('Recommended events') }}</div>
              <item
                v-for="item in recommendedItems"
                :key="item.id"
                :item="item"
                @showDetails="onShowDetails(item)"
                @showOnMap="onShowOnMap(item)"
                class="md-layout md-layout-item md-size-50 md-small-size-75 md-xsmall-size-95 mx-auto"
              />
            </template>

            <template v-if="currentAndFutureItems.length">
              <div class="agenda-section-label md-layout-item md-size-100">{{ $t('Current and upcoming') }}</div>
              <item
                v-for="item in currentAndFutureItems"
                :key="item.id"
                :item="item"
                @showDetails="onShowDetails(item)"
                @showOnMap="onShowOnMap(item)"
                class="md-layout md-layout-item md-size-50 md-small-size-75 md-xsmall-size-95 mx-auto"
              />
            </template>

            <template v-if="pastItems.length">
              <div class="agenda-section-label md-layout-item md-size-100">{{ $t('Ended') }}</div>
              <item
                v-for="item in pastItems"
                :key="item.id"
                :item="item"
                @showDetails="onShowDetails(item)"
                @showOnMap="onShowOnMap(item)"
                class="md-layout md-layout-item md-size-50 md-small-size-75 md-xsmall-size-95 mx-auto"
              />
            </template>
          </div>
          <no-data
            class="md-layout-item md-size-75 md-medium-size-90 md-xsmall-size-95 mx-auto text-center"
            v-else
          />
        </div>
      </div>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedItemForHtml }">
      <modal v-if="selectedItemForHtml" @close="selectedItemForHtml = null">
        <template slot="header">
          <h3 class="title text-center">{{selectedItemForHtml.description.title}}</h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedItemForHtml = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div v-html="selectedItemForHtml.description.content"></div>

        </template>
        <template slot="footer">
          <div
              v-if="selectedItemForHtml.partners.length"
              style="margin:25px 0px"
              class="md-layout md-layout-item md-size-100"
            >
              <h3 class="text-primary bold" style="margin-bottom:5px">{{$t(`Partners`)}}</h3>
              <hr class="text-primary" />
              <partner-item v-for="p in selectedItemForHtml.partners" :key="p.id" :item="p" />
            </div>
        </template>
      </modal>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedRoomData }">
      <modal v-if="selectedRoomData" @close="selectedRoomData = null" id="building-modal">
        <template slot="header">
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedRoomData = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <building-details
            :id="selectedRoomData.buildingId"
            :floorId="selectedRoomData.floorId"
            :roomId="selectedRoomData.roomId"
            :readonly="true"
          />
        </template>

      </modal>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import axios from "@/util/axios";
import { Modal } from "@/components";
import Item from "./components/CulturalEvents/ListItem.vue";
import PageHeader from "./layout/PageHeader";
import NoData from "@/pages/authenticated/NoData";

import BuildingDetails from "@/pages/authenticated/BuildingDetailsPage.vue";
import PartnerItem from "./components/Partners/PartnerListItem.vue";
//import PartnerSimple from "./components/Partners/PartnerListItemSimple.vue";

export default {
  components: { Item, Modal, PageHeader, NoData, BuildingDetails, PartnerItem /*, PartnerSimple */},
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  data() {
    return {
      loaded: false,
      selectedItemForHtml: null,
      selectedRoomData: null,
      items: [],
      now: new Date(),
      image: require("@/assets/img/conference/landing-bg-fe26.jpg") // header img
    };
  },
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    }),
    recommendedItems() {
      return this.items.filter(i => i.isRecommended);
    },
    currentAndFutureItems() {
      return this.items.filter(i => !i.isRecommended && !this.isPast(i));
    },
    pastItems() {
      return this.items.filter(i => !i.isRecommended && this.isPast(i));
    }
  },
  methods: {
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        this.items = (
          await axios.get("public/conferences/conference/cultural-events", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data.sort((r, p) => {
          return new Date(r.startDate) > new Date(p.startDate);
        });
      } finally {
        loader.hide();
        this.loaded = true;
      }
    },
    async onShowOnMap(item) {
      if (!item.roomId) return;

      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        let result = (
          await axios.get("public/conferences/conference/roomData", {
            params: {
              id: item.roomId
            }
          })
        ).data;

        this.selectedRoomData = result;
      } finally {
        loader.hide();
      }
    },
    isPast(item) {
      if (!item.endDate) return false;
      return new Date(item.endDate) <= this.now;
    },
    async onShowDetails(item) {
      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        let result = (
          await axios.get(
            "public/conferences/conference/cultural-events/details",
            {
              params: {
                id: item.id,
                language: this.language.code
              }
            }
          )
        ).data;

        item.description.content = result;
        this.selectedItemForHtml = item;
      } finally {
        loader.hide();
      }
    }
  },
  async mounted() {
    await this.loadData();
    this._nowTimer = setInterval(() => { this.now = new Date(); }, 60000);
  },
  beforeDestroy() {
    clearInterval(this._nowTimer);
  },
  watch: {
    async language() {
      this.model = { description: {}, panels: [] };
      await this.loadData();
    }
  }
};
</script>
<style>
.modal-container {
  min-width: 90% !important;
}
.md-size-20 {
  max-width: 20% !important;
  min-width: 20% !important;

}
</style>
<style lang="scss" scoped>

h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}

.agenda-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #aaaaaa;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 24px 0 4px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #eeeeee;
}
</style>
